import { Box, Button, Typography } from '@mui/material';
import { Student } from 'common/hooks/useStudentSelection';
import LoadingScreen from '@common/components/LoadingScreen';
import { useState } from 'react';
import Image from '@common/components/Image';

type ScreenerProps = {
  student: Student;
  advanceStep: () => void;
};

const SCREENER_LINK = 'https://www.ixl.com/screener/arena';

export function Screener({ student, advanceStep }: ScreenerProps) {
  const [screenerLinkClicked, setScreenerLinkClicked] = useState<boolean>(
    localStorage.getItem('doneClick') === 'true'
  ); // AI-GEN - Cursor - GPT4
  const [loadingResults, setLoadingResults] = useState(false);

  const openScreener = () => {
    setTimeout(() => {
      setScreenerLinkClicked(true);
    }, 3000);

    // open screener link in new tab
    window.open(SCREENER_LINK, '_blank');
    localStorage.setItem('doneClick', 'true'); // AI-GEN - Cursor - GPT4
  };

  const doneWithScreener = () => {
    setLoadingResults(true);
    localStorage.removeItem('doneClick'); // AI-GEN - Cursor - GPT4
    advanceStep();
  };

  return (
    <>
      <Typography variant="h3" marginBottom={4}>
        {loadingResults ? 'Fetching your Screener results...' : 'Start with a simple screener'}
      </Typography>

      {loadingResults ? (
        <LoadingScreen positionFixed={false} />
      ) : (
        <>
          <Typography variant="body1" marginY={2}>
            Hello {student.name}! Welcome to the first step of your exciting mastery challenge. To
            kickstart your journey, we invite you to take the{' '}
            <strong>IXL Universal Screener</strong>. This special test is designed to assess your
            current skills in math and recommend the most suitable grade level for you to compete
            in.
          </Typography>
          <Typography variant="body1" marginY={2}>
            Remember, the screener is here to guide you towards a level where you can truly shine
            and challenge yourself. Once you've completed the screener, we'll use your results to
            suggest a competitive grade level that aligns with your abilities. Ready to discover
            your potential? Let's get started!
          </Typography>
          <Typography variant="body1" marginY={2}>
            <strong>Already finished?</strong> come back soon to see your results!
          </Typography>

          <Box width="100%" display="flex" justifyContent="center" marginY={4}>
            <Button variant="outlined" sx={{ padding: 2 }} onClick={() => openScreener()}>
              Take IXL Universal Screener
            </Button>
          </Box>

          <Box
            width="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            marginY={4}
          >
            <Typography variant="body1" marginY={2} textAlign="center">
              In IXL, select <strong>Sign in with Google</strong> and choose your 2hour learning
              account
            </Typography>
            <Box width="226px" height="auto">
              <Image
                visibleByDefault
                src="/assets/illustrations/illustration_ixl_login.png"
                alt="ixl-login"
              />
            </Box>
          </Box>

          {screenerLinkClicked && (
            <>
              <Typography variant="body1" marginY={2}>
                <strong>Done with the IXL Screener?</strong> Click the button below:
              </Typography>
              <Box width="100%" display="flex" justifyContent="center" marginY={4}>
                <Button variant="outlined" sx={{ padding: 2 }} onClick={() => doneWithScreener()}>
                  I'm Done with the IXL Universal Screener
                </Button>
              </Box>
            </>
          )}
        </>
      )}
    </>
  );
}
